export default __webpack_public_path__ + "static/media/fontainebleau9.a7857896.jpg";